import { render, staticRenderFns } from "./ArticlePreviewFull.vue?vue&type=template&id=f4c5fcf6"
import script from "./ArticlePreviewFull.vue?vue&type=script&lang=js"
export * from "./ArticlePreviewFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports